module.exports = __webpack_public_path__ + "img/info-circle-solid.4bc4d0b9.svg";